import React, { useContext } from "react";
import { withRouter, useHistory } from "react-router-dom";
import Moment from "react-moment";
import "moment-timezone";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Fragment } from "react";
import useTokenCheck from "../../hooks/useTokenCheck";
import CardContext from "../../context/card/CardContext";
import NavigationContext from "../../context/navigation/NavigationContext";
import { env } from "../../env";

const CardItem = (props) => {
  const { card, labels, getIndividualContracts } = props;
  const cardContext = useContext(CardContext);
  const { modifySubscription, modifyRecharge } = cardContext;
  const navigationContext = useContext(NavigationContext);
  const { setNavigationPage } = navigationContext;
  // let rechargeable = "";
  // let subscriptionInfo = "";
  let contracts = getIndividualContracts(card);
  contracts = contracts?.length > 0 ? [contracts[0]] : [card?.contracts[0]];
  console.log("CONTRACT:", contracts[0]);
  let balance = contracts[0]?.unitsLeft ? contracts[0]?.unitsLeft / 100 : 0;
  // if (card && contracts) {
  //   if (contracts > 0) {
  //     rechargeable = contracts[0].rechargeable ? "Yes" : "No";
  //     subscriptionInfo =
  //       contracts[0].subscriptionInfo.state === "NoSubscription" ? "No" : "Yes";
  //     balance = contracts[0].unitsLeft / 100;
  //   }
  // }
  const history = useHistory();
  const { hasTokenExpired } = useTokenCheck();
  const setCurrent = async (e) => {
    e.preventDefault();
    await hasTokenExpired();
    await props.setCurrent(card, "show-detail");
  };

  const doSubscription = async (e, contract) => {
    e.preventDefault();
    await hasTokenExpired();
    await props.setCurrent(card);
    modifySubscription(contract);
    setNavigationPage("Subscribe");
    history.push("/single-subscribe");
  };
  const doRecharge = async (e, contract) => {
    e.preventDefault();
    await hasTokenExpired();
    await props.setCurrent(card);
    modifyRecharge(contract);
    setNavigationPage("Recharge");
    history.push("/recharge/individual");
  };

  return (
    <Fragment>
      <Container fluid role="region">
        <Row>
          <Col className="CardItem__cardTitle">
            <h2>{card?.profileName}</h2>
          </Col>
        </Row>
        <Row className="CardItem__cardTitle__cardItems">
          <Col lg={9}>
            <Row className="CardItem__cardTitle__lineItem">
              <Col lg="3">{labels["SerialNumber"]}:</Col>
              <Col>
                <strong>{card?.serialNumber}</strong>
              </Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
            <Row className="CardItem__cardTitle__lineItem">
              <Col lg="3">Fare Type:</Col>
              <Col lg="3">
                <strong>{card?.profileName}</strong>
              </Col>
              <Col>Issued On:</Col>
              <Col lg="4">
                <strong>
                  <Moment
                    format="MM/DD/YYYY hh:mm A"
                    tz={env.REACT_APP_HMW_TIME_ZONE}
                  >
                    {card?.emissionDate}
                  </Moment>
                </strong>
              </Col>
            </Row>
            <Row className="CardItem__cardTitle__lineItem">
              <Col lg="3">Expires On:</Col>
              <Col lg="4">
                {" "}
                <strong>
                  <Moment
                    format="MM/DD/YYYY hh:mm A"
                    tz={env.REACT_APP_HMW_TIME_ZONE}
                  >
                    {card?.expirationDate}
                  </Moment>
                </strong>
              </Col>
              <Col></Col>
              <Col>
                <div className="CardItem__cardTitle__lineItem__pill">
                  {card.status === "InCirculation" ? "Active" : "Inactive"}
                </div>
              </Col>
            </Row>
            <Row className="CardItem__cardTitle__lineItem">
              <Col lg="3">Reloadable: </Col>
              <Col>
                <strong>{contracts[0]?.rechargeable ? "Yes" : "No"}</strong>{" "}
              </Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
            <Row
              className={
                contracts[0]?.subscriptionInfo?.state === "Active"
                  ? "CardItem__cardTitle__lineItem__start"
                  : "CardItem__cardTitle__lineItem"
              }
            >
              <Col lg="3">Subscription:</Col>
              <Col>
                <strong>
                  {contracts[0]?.subscriptionInfo?.state === "NoSubscription"
                    ? "No"
                    : "Yes"}
                </strong>{" "}
              </Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
            </Row>
            {contracts[0]?.subscriptionInfo?.state === "Active" && (
              <Row className="CardItem__cardTitle__lineItem">
                <Col lg="3">Threshold Amount:</Col>
                <Col>
                  <strong>
                    $
                    {(
                      contracts[0]?.subscriptionInfo?.trigger?.threshold / 100
                    ).toFixed(2)}
                  </strong>
                </Col>

                <Col lg="2">Reload Amount: </Col>
                <Col>
                  <strong>
                    $
                    {(
                      contracts[0]?.subscriptionInfo?.rechargeValue
                        ?.rechargeValue / 100
                    ).toFixed(2)}
                  </strong>
                </Col>

                <Col lg="2">Max Reloads:</Col>
                <Col>
                  <strong>
                    {
                      contracts[0]?.subscriptionInfo
                        ?.maxNumberOfRechargesPerPeriod
                    }
                  </strong>{" "}
                  per month
                </Col>
              </Row>
            )}
          </Col>
          <Col xs="12" lg="3" className="CardItem__cardTitle__cardActions">
            <Container fluid className="CardItem__cardTitle__cardActions__list">
              <Row className="CardItem__cardTitle__cardActions__list__item">
                <div className="CardItem__cardTitle__cardActions__pill">
                  Card Balance $ {balance}
                </div>
              </Row>
              <Row className="CardItem__cardTitle__cardActions__list__item">
                <button
                  id="btnRecharge"
                  name="btnRecharge"
                  className={
                    contracts[0]?.rechargeable
                      ? "CardItem__cardTitle__cardActions__action btn btn-primary"
                      : "CardItem__cardTitle__cardActions__action btn btn-disabled"
                  }
                  onClick={(e) => doRecharge(e, contracts[0])}
                  disabled={!contracts[0]?.rechargeable}
                >
                  Reload
                </button>
              </Row>
              <Row className="CardItem__cardTitle__cardActions__list__item">
                <button
                  id="btnSubscription"
                  name="btnSubscription"
                  className={
                    contracts[0]?.subscriptionAllowed ||
                    contracts[0]?.subscriptionInfo?.state === "Active"
                      ? "CardItem__cardTitle__cardActions__action btn btn-primary"
                      : "CardItem__cardTitle__cardActions__action btn btn-disabled"
                  }
                  onClick={(e) => doSubscription(e, contracts[0])}
                  disabled={
                    !(
                      contracts[0]?.subscriptionAllowed ||
                      contracts[0]?.subscriptionInfo?.state === "Active" ||
                      contracts[0]?.rideSponsorContract
                    )
                  }
                >
                  {contracts[0]?.subscriptionInfo?.state === "NoSubscription"
                    ? "Add Subscription"
                    : "Manage Subscription"}
                </button>
              </Row>
              <Row className="CardItem__cardTitle__cardActions__list__item">
                <button
                  id="btnCardDetails"
                  name="btnCardDetails"
                  className="CardItem__cardTitle__cardActions__action btn btn-primary"
                  onClick={setCurrent}
                >
                  Card Details
                </button>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
      {/* <div className="card">
        <div className="CardItem__cardTitle">{card.profileName}</div>

        <div className="CardItem__cardTitle__cardItems">
          <ul>
            <li>
              <div className="CardItem__cardTitle__lineItem">
                <div>{labels["SerialNumber"]}: </div>
                <div>
                  <strong>{card.serialNumber}</strong>
                </div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </li>
            <li>
              <div className="CardItem__cardTitle__lineItem">
                <div> Fare Type: </div>
                <div>
                  <strong>{card.profileName}</strong>
                </div>
                <div>Issued On: </div>
                <div>
                  <strong>
                    <Moment format="MM/DD/YYYY hh:mm A" tz={env.REACT_APP_HMW_TIME_ZONE}>
                      {card.emissionDate}
                    </Moment>
                  </strong>
                </div>
                <div></div>
              </div>
            </li>
            <li>
              <div className="CardItem__cardTitle__lineItem">
                <div>Expires On: </div>
                <div>
                  <strong>
                    <Moment format="MM/DD/YYYY hh:mm A" tz={env.REACT_APP_HMW_TIME_ZONE}>
                      {card.expirationDate}
                    </Moment>
                  </strong>
                </div>
                <div></div>
                <div></div>
                <div>
                  <div className="pill">
                    {card.status === "InCirculation" ? "Active" : "Inactive"}
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className="CardItem__cardTitle__lineItem">
                <div>Rechargeable: </div>
                <div>
                  <strong>{rechargeable}</strong>{" "}
                </div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </li>
            <li>
              <div className="CardItem__cardTitle__lineItem">
                <div>Subscription: </div>
                <div>
                  <strong>{subscriptionInfo}</strong>{" "}
                </div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              {subscriptionInfo === "No" && (  
              <div className="CardItem__cardTitle__lineItem">
                <div>Threshold Amount: </div>
                <div>
                  <strong>
                    {contracts[0].subscriptionInfo.trigger.threshold}
                  </strong>{" "}
                </div>
                <div></div>
                <div>Recharge Amount: </div>
                <div>
                  {contracts[0].subscriptionInfo.rechargeValue.rechargeValue}
                </div>
              </div>
               )} 
            </li>
          </ul>
        </div>
        <div className="CardItem__cardTitle__cardActions">
          <div className="pill">Card Balance $ {balance}</div>
          <div
            className={
              contracts[0].rechargeable ? "btn btn-primary" : "btn btn-disabled"
            }
          >
            Recharge
          </div>
          <div
            className={
              contracts[0].subscriptionAllowed
                ? "btn btn-primary"
                : "btn btn-disabled"
            }
            onClick={doSubscription}
          >
            {contracts[0].subscriptionAllowed && subscriptionInfo === "No"
              ? "Add Subscription"
              : "Manage Subscription"}
          </div>
          <div className="btn btn-primary" onClick={setCurrent}>
            Card Details
          </div>
        </div>
      </div> */}
    </Fragment>
  );
};

export default withRouter(CardItem);
